import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { AngularTokenService } from 'angular-token';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  redirectUrl: string;
  headers: HttpHeaders;
  currentUserDetails: any;
  options: any;

  private userDetails = new BehaviorSubject<any>({});
  currentMessage = this.userDetails.asObservable();

  constructor(
    private tokenService: AngularTokenService,
    public router: Router,
    private http: HttpClient,
  ) { }

  resetPassword(form, headersOptions) {
    var obj = {
      'password': form.value.password,
      'password_confirmation': form.value.passwordConfirmation,
    }

    let url = environment.apiBaseUrl + '/auth/password';
    return this.http.put(url, obj, headersOptions)
  }

  logOut() {
    this.redirectUrl = undefined;
    localStorage.clear();
    this.router.navigate(['/login']);
    return this.tokenService.signOut().subscribe(
      res => {
        localStorage.clear();
        this.router.navigate(['/login']);
        window.location.href = '/login'
      }, err => {
        console.log(err);
      }
    );
  }

  isLoggedIn(): boolean {
    let tokens = localStorage.getItem('token');
    if (tokens) {
      return true;
    }
    return false;
    // return this.tokenService.userSignedIn();
  }

  currentUserData() {
    this.userDetails.next(this.tokenService.currentUserData)
    return this.tokenService.currentUserData;
  }

  getHeaders() {
    this.headers = new HttpHeaders({ 'enctype': 'multipart/form-data' });
    this.headers.append('Accept', 'application/json');
    this.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    this.options = this.headers;
    return this.options;
  }

  getInternationalCode() {
    return this.http.get('./assets/phone_number/international_code.json')
  }

  resendMail(email) {
    let url = environment.apiBaseUrl + '/resend_confirmation_mail?email=' + email
    return this.http.get(url)
  }

  resendForgotPasswordMail(email) {
    let url = environment.apiBaseUrl + '/auth/password?email=' + email
    return this.http.get(url)
  }

  getEngageToken(id) {
    let url = environment.apiBaseUrl + '/engage/get_engage_token?user_id=' + id;
    return this.http.get(url, this.options)
  }

  signin(token) {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(environment.apiBaseUrl + '/auth/sign_in', { headers: headers });
  }

  // New method to test API health
  testApiHealth(token:string): Observable<any> {
    // Add your API health check logic here, e.g., an HTTP call
    console.log('Testing API health...');
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(environment.apiBaseUrl + '/healthcheck', { headers: headers });
    // Example: this.http.get('/healthcheck').subscribe(response => console.log(response));
  }
}